// extracted by css-extract-rspack-plugin
export default {"rangeLink":"_2b414d7c"};